import { ApiService } from "./Api";

export const createApiService = (apiType: "goPersonal" | "packs", accessToken: string) => {
  const baseUrls = {
    goPersonal: import.meta.env.VITE_GOPERSONAL_API_SERVER + 'v1',
    packs: import.meta.env.VITE_PACKS_API_SERVER + 'api/v1',
  };

  return new ApiService(baseUrls[apiType], accessToken);
};
